/* tslint:disable */

declare var Object: any;
export interface EstadoInterface {
  "idEstado"?: number;
  "descripcion": string;
}

export class Estado implements EstadoInterface {
  "idEstado": number;
  "descripcion": string;
  constructor(data?: EstadoInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Estado`.
   */
  public static getModelName() {
    return "Estado";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Estado for dynamic purposes.
  **/
  public static factory(data: EstadoInterface): Estado{
    return new Estado(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Estado',
      plural: 'Estados',
      path: 'Estados',
      idName: 'idEstado',
      properties: {
        "idEstado": {
          name: 'idEstado',
          type: 'number'
        },
        "descripcion": {
          name: 'descripcion',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/lbsdk/models/Estado.ts